import axios from "axios"
import { notify } from "src/components/notification-toast"
import { NOTIFICATION_MSG } from "src/constants/notification-mesage"

type PlanInterestPayload = {
  planId?: number
  planName?: string
  price?: string | number
  listingId?: string
  listingTitle?: string
  address?: string
  landlordName?: string
  landlordEmail?: string
  landlordPhone?: string
  source: "list-with-us" | "dashboard" | string
}

export async function sendPlanInterest(payload: PlanInterestPayload) {
  try {
    const url = (process.env.REACT_APP_GRAPHQL_URI || "") + "/api/plan-interest"
    await axios.post(url, payload)
    notify(
      NOTIFICATION_MSG.Success,
      "Thank you for your interest. Our team will reach out to you regarding the next steps."
    )
  } catch (e) {
    notify(NOTIFICATION_MSG.error, "We could not record your interest. Please try again.")
    throw e
  }
}


